module.exports = __webpack_public_path__ + "static/img/solution-banner.74c95c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-banner.jpg
// module id = qDYq
// module chunks = 1